<template>
	<div>
		<div v-if="!isLoading">
			<vs-table
				:data="prospectsUrl"
				max-items="100"
				pagination
				search
				ref="ref-ProspectsUrl-ideas-table"
				class="mt-5"
				noDataText="Aucun(e) Urls."
			>
				<template slot="thead">
					<vs-th style="pointer-events: auto" sort-key="keyword">Urls</vs-th>
					<!-- Madame ou Monsieur -->
					<!-- <vs-th style="pointer-events: auto" sort-key="cpc">CPC</vs-th> -->
					<!-- <vs-th style="pointer-events: auto" sort-key="cpc">Volume</vs-th> -->
				</template>
				<template slot-scope="{ data }">
					<vs-tr
						:data="data[indextr]"
						:key="indextr"
						v-for="(tr, indextr) in data"
					>
						<vs-td :data="data[indextr].url"
							><vs-input v-model="tr.url"></vs-input
						></vs-td>
					</vs-tr>
				</template>
			</vs-table>
			<div class="flex justify-end mt-4">
				<vs-button color="success" @click="updateProspectsUrl()"
					>Mettre à jour</vs-button
				>
			</div>
		</div>
		<circular-loader v-else />
	</div>
</template>

<script>
import utilsMixin from "../../../mixins/utilsMixin";
import dbFieldConvertorMixin from "../../../mixins/dbFieldConvertorMixin";
import ProspectSearch from "../../../entities/ProspectSearch";
import CircularLoader from "../../../components/widgets/loader/CircularLoader.vue";

export default {
	components: { CircularLoader },
	name: "UpdateProspectsUrlPage",
	props: {
		projectId: {
			type: Number,
			default: 0,
		},
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	// Your component's logic goes here
	data() {
		return {
			prospectsUrl: [],
			oldProspectsUrl: [],
			isLoading: false,
			// mainUrl: null,
		};
	},
	watch: {},
	computed: {
		// Your component's computed properties go here
		// newProspects() {
		// 	return store.state.newProspects;
		// },
	},
	created() {
		this.getProspectsUrlByProjectId();
	},
	updated() {},
	methods: {
		getProspectsUrlByProjectId() {
			this.isLoading = true;
			ProspectSearch.getProspectsByProjectId(this.projectId)
				.then((response) => {
					this.prospectsUrl = response;
					this.oldProspectsUrl = JSON.parse(JSON.stringify(response));
				})
				.finally(() => {
					this.isLoading = false;
				});
		},
		/**check updated list */
		getChangedObjects(oldData, newData) {
			const sortedOld = [...oldData].sort((a, b) => a.id - b.id);
			const sortedNew = [...newData].sort((a, b) => a.id - b.id);

			return sortedNew.filter((newItem) => {
				const oldItem = sortedOld.find((item) => item.id === newItem.id);

				if (!oldItem) return true; // New item

				return oldItem.url !== newItem.url;
			});
		},
		updateProspectsUrl() {
			const changedProspectsUrl = this.getChangedObjects(
				this.oldProspectsUrl,
				this.prospectsUrl
			);
			if (changedProspectsUrl.length === 0) {
				this.$vs.notify({
					title: "Aucun changement",
					text: "Aucun changement n'a été détecté.",
					color: "warning",
				});
				return;
			} else {
				const newList = changedProspectsUrl.map((item) => ({
					id: item.id,
					url: item.url,
				}));
				ProspectSearch.updateProspectUrls(newList)
					.then((response) => {
						this.$vs.notify({
							title: "Succès",
							text: "Les mots-clés ont été mis à jour avec succès.",
							color: "success",
							time: 1000,
						});
						this.getProspectsUrlByProjectId();
					})
					.catch((error) => {
						this.$vs.notify({
							title: "Echec",
							text: "Une erreur s'est produite lors de la mise à jour des mots-clés.",
							color: "danger",
						});
					});
			}
		},
	},
};
</script>

<style scoped>
</style>